export default {
  data() {
    return {
      tableHeight: 100,
      minusHeight: 176
    }
  },
  methods: {
    getHeight() {
      let height = window.innerHeight - this.minusHeight
      console.log(height)
      if (this.$refs.QueryForm && this.$refs.QueryForm.$el) {
        height = height - (this.$refs.QueryForm.$el.clientHeight || 0)
      }
      console.log(height)
      this.tableHeight = height
    }
  },
  mounted() {
    this.getHeight()
  },
  created() {
    window.addEventListener('resize', this.getHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  }

}
